import ReviewCard from '@/components/base/ReviewCard';
import { reviews } from '@/mocks/reviews';

export default function ReviewSection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-accent-600 tracking-wider">读者评价</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            读者都在说
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            来自全国漫画爱好者的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reviews.map((review, index) => (
            <ReviewCard
              key={review.id}
              review={review}
              faded={index === reviews.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
}